import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { CONTACT as DEFAULT_CONTACT } from "../data/site";

const SiteSettingsContext = createContext(DEFAULT_CONTACT);

export const SiteSettingsProvider = ({ children }) => {
  const [contact, setContact] = useState(DEFAULT_CONTACT);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/settings/site`)
      .then((r) => setContact({ ...DEFAULT_CONTACT, ...(r.data || {}) }))
      .catch(() => {});
  }, []);

  return <SiteSettingsContext.Provider value={contact}>{children}</SiteSettingsContext.Provider>;
};

export const useContact = () => useContext(SiteSettingsContext);
